const ENV = {
  MIXPANEL_PROJECT_TOKEN: "b0819b0bd1be9ece4e1048625a7ff266",

  //
  // LOCAL DEV
  //
  // LOCAL_ADDRESS_SUPERFLUID_RESOLVER: "0xA91412bF746fC144083236B5F89978d9085dBfE9",
  // LOCAL_ADDRESS_SUPERFLUID_HOST: "0x6393a5FBC8A49679EE81bc1297d04A487335A64E",
  // LOCAL_ADDRESS_SUPERFLUID_CFA: "0x8e881982682d7475b361103B9D934d2616331959",
  // LOCAL_ADDRESS_SUPERFLUID_IDA: "0xdBFe427E4BE1Bf87A0c59793e760CbF013806A0B",
  // LOCAL_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: "",
  // LOCAL_ADRESS_DAI: "0xEBE20C85E334286d538DAb1aC81eb88Ca6d9aAe7",
  // LOCAL_ADRESS_DAIX: "0xe34e607aA68dd29A26de16Db4e0Fe3ebfB389C81",
  // LOCAL_ADRESS_ETHG: "0x5EbcB2b8E2e130528D523195BE46455E6Ac74F5F",
  // LOCAL_ADRESS_ETHGX: "0xE4909B69b7d4153ccd6cd7C0E53d04002fa0E7Ca",
  // LOCAL_ADDRESS_DCA_DAIX_ETHGX: "0x24e9be9C34dD5907db3CD7123aBFA2E40CA38777",
  // LOCAL_ADDRESS_DCA_DAIX_ETHGX_IDX: 88,

  //
  // LOCAL MAINNET FORK
  //
  LOCAL_ADDRESS_SUPERFLUID_RESOLVER: "0xE0cc76334405EE8b39213E620587d815967af39C",
  LOCAL_ADDRESS_SUPERFLUID_HOST: "0x3E14dC1b13c488a8d5D310918780c983bD5982E7",
  LOCAL_ADDRESS_SUPERFLUID_CFA: "0x6EeE6060f715257b970700bc2656De21dEdF074C",
  LOCAL_ADDRESS_SUPERFLUID_IDA: "0xB0aABBA4B2783A72C52956CDEF62d438ecA2d7a1",
  LOCAL_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: "0xcfA132E353cB4E398080B9700609bb008eceB125",

  // erc 20s
  LOCAL_ADRESS_USDC: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
  LOCAL_ADRESS_WBTC: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
  LOCAL_ADRESS_WETH: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
  LOCAL_ADRESS_WMATIC: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
  LOCAL_ADRESS_LINK: "0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39",
  LOCAL_ADRESS_AMKT: "0xb87904db461005fc716a6bf9f2d451c33b10b80b",
  LOCAL_ADRESS_GNS: "0xe5417af564e4bfda1c483642db72007871397896",
  LOCAL_ADRESS_CRV: "0x172370d5cd63279efa6d502dab29171933a610af",

  // supertokens
  LOCAL_ADRESS_USDCX: "0xCAa7349CEA390F89641fe306D93591f87595dc1F",
  LOCAL_ADRESS_WBTCX: "0x4086eBf75233e8492F1BCDa41C7f2A8288c2fB92",
  LOCAL_ADRESS_WETHX: "0x27e1e4E6BC79D93032abef01025811B7E4727e85",
  LOCAL_ADRESS_WMATICX: "0xe04ad5d86c40d53a12357e1ba2a9484f60db0da5",
  LOCAL_ADRESS_LINKX: "0xa1bd23b582c12c22e5e264a0a69847ca0ed9f2b0",
  LOCAL_ADRESS_AMKTX: "0x5d6Fdc854b46e8B237bd2cCC2714cFA3D18cF58E",
  LOCAL_ADRESS_GNSX: "0xfd0577c4707367ff9b637f219388919d3be37592",
  LOCAL_ADRESS_CRVX: "0x96eac3913bab431c28895f02cf5c56ad2dab8439",

  // pools
  LOCAL_ADDRESS_DCA_USDCX_WBTCX: "0x95344c5C503da77DE3Fa4D05BB4cb578e3A621B2",
  LOCAL_ADDRESS_DCA_USDCX_WETHX: "0x696703A87e3D6ce0480B79ACc4F2F63Ed9ebB547",
  LOCAL_ADDRESS_DCA_USDCX_WMATICX: "0xfec0371055D9d3ff6b5318f2FFD50777F2b97F8a",
  LOCAL_ADDRESS_DCA_USDCX_LINKX: "0xD1CdE2eD5884B63D017Ea1128C5614750033E224",
  LOCAL_ADDRESS_DCA_USDCX_AMKTX: "0x8c5BD7D0a0B7c9a60f2B2020eC6cA183843455c2",
  LOCAL_ADDRESS_DCA_WMATICX_GNSX: "0x6DfEf3A6ee1d1dd293bB238e64377E904b3B0613",
  LOCAL_ADDRESS_DCA_WMATICX_CRVX: "0xE891135b66559E13F5B5d6bF02D1eAA089D0E387",
  LOCAL_ADDRESS_DCA_USDCX_WBTCX_IDX: 88,
  LOCAL_ADDRESS_DCA_USDCX_WETHX_IDX: 88,
  LOCAL_ADDRESS_DCA_USDCX_WMATICX_IDX: 88,
  LOCAL_ADDRESS_DCA_USDCX_LINKX_IDX: 88,
  LOCAL_ADDRESS_DCA_USDCX_AMKTX_IDX: 88,
  LOCAL_ADDRESS_DCA_WMATICX_GNSX_IDX: 88,
  LOCAL_ADDRESS_DCA_WMATICX_CRVX_IDX: 88,

  //
  // POLYGON MUMBAI
  //
  MUMBAI_ADDRESS_SUPERFLUID_RESOLVER: "0x8C54C83FbDe3C59e59dd6E324531FB93d4F504d3",
  MUMBAI_ADDRESS_SUPERFLUID_HOST: "0xEB796bdb90fFA0f28255275e16936D25d3418603",
  MUMBAI_ADDRESS_SUPERFLUID_CFA: "0x49e565Ed1bdc17F3d220f72DF0857C26FA83F873",
  MUMBAI_ADDRESS_SUPERFLUID_IDA: "0x804348D4960a61f2d5F9ce9103027A3E849E09b8",
  MUMBAI_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: "0xcfA132E353cB4E398080B9700609bb008eceB125",

  // super apps
  MUMBAI_ADDRESS_DCA_STABLEX_ENCX: "0x77f3cdaa428f930b7f373021e8fdd9e1d8ea393a",
  MUMBAI_ADDRESS_DCA_STABLEX_ENCX_IDX: 88,
  MUMBAI_ADDRESS_DCA_STABLEX_BTFDCAX: "0xFF0a4792B1731382F157d762332b1724193631b7",
  MUMBAI_ADDRESS_DCA_STABLEX_BTFDCAX_IDX: 88,

  // erc20 and super tokens
  MUMBAI_ADDRESS_STABLE: "0x7934c296F43947ea902Ad7C03fd5CD3031bf013D",
  MUMBAI_ADDRESS_STABLEX: "0x358b34D52675C6D8B9b932015662625292e1Fd12",
  MUMBAI_ADDRESS_ENC: "0xe70f127D37582dfD51c104F8CF730055658C16A8",
  MUMBAI_ADDRESS_ENCX: "0xC93296628282DC92b9eBCa6F9423FE8b63730407",
  MUMBAI_ADDRESS_BTFDCA: "0x86d0773b8053721301f6aa066143d6191ef5613c",
  MUMBAI_ADDRESS_BTFDCAX: "0x7540425F0D83B170Eec5E328354AC2188C532d2A",

  //
  // POLYGON MAINNET
  //
  POLYGON_MAINNET_ADDRESS_SUPERFLUID_RESOLVER: "0xE0cc76334405EE8b39213E620587d815967af39C",
  POLYGON_MAINNET_ADDRESS_SUPERFLUID_HOST: "0x3E14dC1b13c488a8d5D310918780c983bD5982E7",
  POLYGON_MAINNET_ADDRESS_SUPERFLUID_CFA: "0x6EeE6060f715257b970700bc2656De21dEdF074C",
  POLYGON_MAINNET_ADDRESS_SUPERFLUID_IDA: "0xB0aABBA4B2783A72C52956CDEF62d438ecA2d7a1",
  POLYGON_MAINNET_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: "0xcfA132E353cB4E398080B9700609bb008eceB125",

  // erc 20s
  POLYGON_MAINNET_ADRESS_USDC: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
  POLYGON_MAINNET_ADRESS_WBTC: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
  POLYGON_MAINNET_ADRESS_WETH: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
  POLYGON_MAINNET_ADRESS_WMATIC: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
  POLYGON_MAINNET_ADRESS_LINK: "0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39",
  POLYGON_MAINNET_ADRESS_AMKT: "0xb87904db461005fc716a6bf9f2d451c33b10b80b",
  POLYGON_MAINNET_ADRESS_GNS: "0xe5417af564e4bfda1c483642db72007871397896",
  POLYGON_MAINNET_ADRESS_CRV: "0x172370d5cd63279efa6d502dab29171933a610af",
  POLYGON_MAINNET_ADRESS_MVX: "0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7",

  // supertokens
  POLYGON_MAINNET_ADRESS_USDCX: "0xCAa7349CEA390F89641fe306D93591f87595dc1F",
  POLYGON_MAINNET_ADRESS_WBTCX: "0x4086eBf75233e8492F1BCDa41C7f2A8288c2fB92",
  POLYGON_MAINNET_ADRESS_WETHX: "0x27e1e4E6BC79D93032abef01025811B7E4727e85",
  POLYGON_MAINNET_ADRESS_WMATICX: "0xe04ad5d86c40d53a12357e1ba2a9484f60db0da5",
  POLYGON_MAINNET_ADRESS_LINKX: "0xa1bd23b582c12c22e5e264a0a69847ca0ed9f2b0",
  POLYGON_MAINNET_ADRESS_AMKTX: "0x5d6Fdc854b46e8B237bd2cCC2714cFA3D18cF58E",
  POLYGON_MAINNET_ADRESS_GNSX: "0xfd0577c4707367ff9b637f219388919d3be37592",
  POLYGON_MAINNET_ADRESS_CRVX: "0x96eac3913bab431c28895f02cf5c56ad2dab8439",
  POLYGON_MAINNET_ADRESS_MVXX: "0xd89c35b586eadfbde1a3b2d36fb5746c6d3601bc",

  // pools
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WBTCX: "0x1d29823340c743a672d03290BCd34Cfc610c550b",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WETHX: "0x9CbA09F68b9c6957e2d70aD1f477CB5988116Bb4",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WMATICX: "0x37b7d5aaE03a74cF3E5DD2bACf5149e791033aC4",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_LINKX: "0x058EB9782cbea03D4C3E3186B05eEff51C685eaD",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_AMKTX: "0x607D34939A507F344EE072F57712581618E5d2B3",
  POLYGON_MAINNET_ADDRESS_DCA_WMATICX_GNSX: "0x3d6c6d4F4136d6a56321cAe092e18BeB5AAaB97B",
  POLYGON_MAINNET_ADDRESS_DCA_WMATICX_CRVX: "0xA055983D0719C85014d1eb35212d7F10B6c15012",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_MVXX: "0x2059d48C0C7cbF21C31d5D081d151A80198c2A9D",
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WBTCX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WETHX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_WMATICX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_LINKX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_AMKTX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_WMATICX_GNSX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_WMATICX_CRVX_IDX: 88,
  POLYGON_MAINNET_ADDRESS_DCA_USDCX_MVXX_IDX: 88,
};

export default ENV;
